import React, { useContext } from 'react';
import { func, number, shape, string } from 'prop-types';

import exportWithBoundary from '../../../../helpers/exportWithBoundary';
import MapCluster from '../../../_atoms/MapCluster';
import MapPin from '../../../_atoms/MapPin';
import { JobMapContext } from '../JobMapContext';
import { CustomPin, MarkerComponent } from './styles';

function JobMapMarker({ marker, onClick }) {
  const { getBrand, primaryColor, mapPinMode, mapPinUrl } =
    useContext(JobMapContext);
  const brand = getBrand(marker.brand_id);
  const logo =
    brand && brand.avatar_small_url ? brand.avatar_small_url : marker.logo;
  const color =
    brand && brand.primary_color ? brand.primary_color : primaryColor;
  let markerEl = <MapPin color={color} imageUrl={logo} offsetAnchor />;
  if (mapPinMode === 'custom' && mapPinUrl) {
    markerEl = <CustomPin src={mapPinUrl} alt='Map pin' />;
  }
  if (marker.locations_count > 1) {
    markerEl = (
      <MapCluster color={primaryColor} count={marker.job_postings_count} />
    );
  }

  return (
    <MarkerComponent onClick={() => onClick(marker)}>
      {markerEl}
    </MarkerComponent>
  );
}

JobMapMarker.propTypes = {
  onClick: func.isRequired,
  marker: shape({
    geohash: string,
    bounds: shape({
      north: number,
      east: number,
      south: number,
      west: number,
    }),
    job_postings_count: number,
    lat: number,
    lng: number,
    locations_count: number,
    logo: string,
  }).isRequired,
};

function JobMapMarkerFallback() {
  return <MarkerComponent />;
}

export default exportWithBoundary(JobMapMarker, JobMapMarkerFallback);
